var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("业务管理")]),
              _c("el-breadcrumb-item", [_vm._v("PO管理")]),
              _c("el-breadcrumb-item", [_vm._v("PO计费单")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "100px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "建单时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.handleDateChange },
                              model: {
                                value: _vm.searchForm.createTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "createTime", $$v)
                                },
                                expression: "searchForm.createTime"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "计费类型" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { clearable: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.billType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "billType", $$v)
                                  },
                                  expression: "searchForm.billType"
                                }
                              },
                              _vm._l(_vm.ticketTypeOptions, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "区域园区" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                on: { focus: _vm.handleSelectFocus },
                                model: {
                                  value: _vm.searchForm.campusName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "campusName", $$v)
                                  },
                                  expression: "searchForm.campusName"
                                }
                              },
                              _vm._l(_vm.campusOptions, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: Object.values(item)[0],
                                    value: Object.values(item)[0]
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "是否超时" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { clearable: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.timeOut,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "timeOut", $$v)
                                  },
                                  expression: "searchForm.timeOut"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "已超时", value: "已超时" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "未超时", value: "未超时" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "PO确认单" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入PO确认单" },
                              model: {
                                value: _vm.searchForm.opTicketid,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "opTicketid", $$v)
                                },
                                expression: "searchForm.opTicketid"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单单号" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入工单单号" },
                              model: {
                                value: _vm.searchForm.ticket_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "ticket_id", $$v)
                                },
                                expression: "searchForm.ticket_id"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "是否结单" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { clearable: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.is_deal,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "is_deal", $$v)
                                  },
                                  expression: "searchForm.is_deal"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "已结单", value: "1" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "待结单", value: "0" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "结单人" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入结单人",
                                clearable: ""
                              },
                              model: {
                                value: _vm.searchForm.completer,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "completer", $$v)
                                },
                                expression: "searchForm.completer"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ]),
                          _c(
                            "el-button",
                            { on: { click: _vm.debouncedExport } },
                            [_vm._v(_vm._s(_vm.exportButtonText))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "title-en" }, [_vm._v("PO计费单")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                  _vm._v("表头设置")
                ])
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.faults, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" }
                }),
                _c("el-table-column", {
                  attrs: { type: "index", label: "序号", width: "60" }
                }),
                _vm._l(_vm.visibleColumns, function(column, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      width: column.width
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              column.prop === "createTime"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row[column.prop]
                                          ? _vm
                                              .$moment(scope.row[column.prop])
                                              .format("YYYY-MM-DD HH:mm:ss")
                                          : "-"
                                      )
                                    )
                                  ])
                                : column.prop === "isChange"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row[column.prop] === 0
                                            ? "info"
                                            : "warning",
                                        size: "small"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row[column.prop] === 0
                                              ? "未变更"
                                              : "已变更"
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : column.prop === "time_out"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row[column.prop] === "已超时"
                                            ? "danger"
                                            : "success",
                                        size: "small"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row[column.prop] || "-"
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : column.prop === "bill_type"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "primary", size: "small" }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row[column.prop] || "-"
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : column.prop === "feedback_status"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row[column.prop] === "已收单"
                                            ? "success"
                                            : "warning",
                                        size: "small"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row[column.prop] || "-"
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : column.prop === "po_num"
                                ? _c("span", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            scope.row.feedback_status ===
                                            "已收单"
                                              ? "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                                scope.row.po_num +
                                                "&isHistory=1"
                                              : "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                                scope.row.po_num,
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v(_vm._s(scope.row.po_num))]
                                    )
                                  ])
                                : column.prop === "svrItem"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        "PO计费单-" + (scope.row.orderNo || "-")
                                      )
                                    )
                                  ])
                                : column.prop === "opTicketid"
                                ? _c("span", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            scope.row.feedback_status ===
                                            "已收单"
                                              ? "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                                scope.row.opTicketid +
                                                "&isHistory=1"
                                              : "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                                scope.row.opTicketid +
                                                "&isHistory=1",
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v(_vm._s(scope.row.opTicketid))]
                                    )
                                  ])
                                : [
                                    "supplierMemo",
                                    "billMemo",
                                    "faultAppendInfo",
                                    "tpcAppendInfo",
                                    "supplierPhoto",
                                    "billPhoto"
                                  ].includes(column.prop)
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                            loading:
                                              _vm.detailLoadingKey ===
                                              scope.row.opTicketid +
                                                "_" +
                                                column.prop
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.openCostPoDetail(
                                                scope.row,
                                                column.prop,
                                                column.label
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                查看详情\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : column.prop === "process_user"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: scope.row[column.prop]
                                          ? "danger"
                                          : "success",
                                        size: "small"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row[column.prop]
                                              ? "已结单"
                                              : "待结单"
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(scope.row[column.prop] || "-")
                                    )
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                })
              ],
              2
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  "append-to-body": true,
                  width: "400px",
                  "close-on-click-modal": false,
                  "custom-class": "columns-dialog",
                  "modal-append-to-body": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: _vm.detailDialog.title,
                  visible: _vm.detailDialog.visible,
                  width: "50%",
                  "before-close": _vm.closeDetailDialog
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.detailDialog, "visible", $event)
                  }
                }
              },
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.formatObjectToArray(_vm.detailDialog.data),
                      border: "",
                      stripe: "",
                      "max-height": "400"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "key", label: "键名", width: "180" }
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "value", label: "值" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              typeof scope.row.value === "object"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        JSON.stringify(scope.row.value, null, 2)
                                      )
                                    )
                                  ])
                                : _c(
                                    "span",
                                    {
                                      staticStyle: { "white-space": "pre-line" }
                                    },
                                    [_vm._v(_vm._s(scope.row.value))]
                                  )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c("el-button", { on: { click: _vm.closeDetailDialog } }, [
                      _vm._v("关闭")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }